var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CreateReservationDateComponent } from '../create-reservation-date/create-reservation-date.component';
import { ReservationService } from 'src/app/shared/services/rest/reservation.service';
import { Reservation } from 'src/app/shared/models/reservation';
import { DateHelper } from 'src/app/shared/utils/date-helper';
import { MessageService } from 'src/app/shared/services/message.service';
import { MessageType } from 'src/app/shared/models/message';
import { OccupancyService } from 'src/app/shared/services/rest/occupancy.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpHelper } from 'src/app/shared/utils/http-helper';
import { CreateReservationDialogComponent } from './create-reservation-dialog-base.component';
import { DeviceService } from 'src/app/shared/services/rest/device.service';
import { ResourceType } from 'src/app/shared/models/resource-type';
var CreateDeviceReservationDialogComponent = /** @class */ (function (_super) {
    __extends(CreateDeviceReservationDialogComponent, _super);
    function CreateDeviceReservationDialogComponent(deviceService, reservationService, occupancyService, messages, translate, language, fb, cdr) {
        var _this = _super.call(this, reservationService, occupancyService, messages, translate, language, fb, cdr) || this;
        _this.deviceService = deviceService;
        return _this;
    }
    Object.defineProperty(CreateDeviceReservationDialogComponent.prototype, "type", {
        get: function () {
            return ResourceType.Gerät;
        },
        enumerable: true,
        configurable: true
    });
    CreateDeviceReservationDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.createForm();
        this.loadData();
        this.loadOccupanciesData(this.params.from, this.params.to)
            .then(function (device) {
            _this.resourceOccupancies = _this.generateResourceOccupancies(device.Occupancies);
        });
        this.resolveArticleLabel('THE_DEVICE');
    };
    /**
     * Load data from server
     *
     * @private
     * @memberof CreateReservationDialogComponent
     */
    CreateDeviceReservationDialogComponent.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reservationObserveable;
            var _this = this;
            return __generator(this, function (_a) {
                this.isLoading = true;
                reservationObserveable = this.isNewReservation ?
                    this.reservationService.getTemplate(String(this.params.idRessource))
                    : this.reservationService.get(String(this.params.idReservation));
                // get Reservation
                reservationObserveable.toPromise().then(function (data) {
                    var reservationData = HttpHelper.getResponseData(data);
                    _this.reservation = Reservation.create(reservationData);
                    // set reservationinfo for existing reservation
                    if (!_this.isNewReservation) {
                        _this.reservationInfo = { header: null, primary: _this.reservation.StatusRemark, secondary: null };
                        _this.translate.get('STATE').subscribe(function (text) {
                            _this.reservationInfo.header = text + ': ' + _this.reservation.Status;
                        });
                        var condition = String(Number(_this.reservation.hasFutureSavedDates())) + String(Number(_this.reservation.IsEditable));
                        var key = void 0;
                        switch (condition) {
                            case '11':
                                key = 'RESERVATION_STATE_EDITABLE';
                                break;
                            case '00':
                            case '01':
                                key = 'RESERVATION_STATE_PAST';
                                break;
                            default:
                                key = 'RESERVATION_STATE_READONLY';
                        }
                        _this.translate.get(key).subscribe(function (text) {
                            _this.reservationInfo.secondary = text;
                        });
                    }
                    // get Roominfo
                    _this.deviceService.get(String(_this.params.idRessource)).toPromise().then(function (roomData) {
                        _this.initLoadedDates(HttpHelper.getResponseData(roomData));
                        _this.isLoading = false;
                    }, function (error) {
                        _this.initLoadedDates(null);
                        _this.handleRequestError(error, 'DEVICE', _this.params.idRessource);
                        _this.isLoading = false;
                    });
                }, function (error) {
                    _this.handleRequestError(error, 'RESERVATION', _this.params.idReservation);
                    _this.isLoading = false;
                });
                // load reservationinfo for new reservation
                if (this.isNewReservation) {
                    this.loadReservationsrecht();
                }
                return [2 /*return*/];
            });
        });
    };
    CreateDeviceReservationDialogComponent.prototype.prepLoadOccupanciesData = function (idRessource) {
        var _this = this;
        var loader = this.deviceService.getAvailableDevices;
        var loaderScope = function (from, to) { return __awaiter(_this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            idDevice: [idRessource],
                            availableFrom: from,
                            availableTo: to,
                            availableOnly: false,
                            timespan: null,
                            ressourceNumber: []
                        };
                        return [4 /*yield*/, loader(params)
                                .toPromise()
                                .then(function (payload) { return payload[0] || []; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        return loaderScope;
    };
    CreateDeviceReservationDialogComponent.prototype.loadOccupanciesData = function (from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var params, that;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            idDevice: [this.params.idRessource],
                            availableFrom: from,
                            availableTo: to,
                            availableOnly: false,
                            timespan: null,
                            ressourceNumber: []
                        };
                        that = this;
                        return [4 /*yield*/, this.deviceService.getAvailableDevices(params)
                                .toPromise()
                                .then(function (payload) { return payload[0] || []; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CreateDeviceReservationDialogComponent.prototype.loadReservationsrecht = function () {
        var _this = this;
        var params = {
            idDevice: [this.params.idRessource],
            availableFrom: this.params.from,
            availableTo: this.params.to,
            availableOnly: false,
            timespan: null,
            ressourceNumber: []
        };
        this.deviceService.getAvailableDevices(params).toPromise().then(function (data) {
            if (data[0] && data[0].ReservationRightId) {
                _this.reservationInfo = { header: null, primary: null, secondary: null };
                _this.translate.get('DEVICE_RESERVATIONRIGHT_HINT_HEADER_' + data[0].ReservationRightId).subscribe(function (text) {
                    _this.reservationInfo.header = text;
                });
                _this.translate.get('DEVICE_RESERVATIONRIGHT_HINT_BODY_' + data[0].ReservationRightId).subscribe(function (text) {
                    _this.reservationInfo.primary = text;
                });
            }
        }, function (error) {
            _this.messages.add(error.message, MessageType.Debug);
        });
    };
    /**
     * Create FormGroup for CreateReservationDateComponent from Occupancy
     *
     * @param {Occupancy} o
     * @returns {FormGroup}
     * @memberof CreateReservationDialogComponent
     */
    CreateDeviceReservationDialogComponent.prototype.createDateFormGroup = function (o) {
        var group = CreateReservationDateComponent.createFormGroupModel(this.fb);
        group.setValue({
            id: o.LessonId,
            date: o.DateTimeFrom,
            dateTimeFrom: String(DateHelper.getMinutesOfDay(o.DateTimeFrom)),
            dateTimeTo: String(DateHelper.getMinutesOfDay(o.DateTimeTo)),
            message: ''
        });
        if (!o.IsEditable) {
            group.disable();
        }
        return group;
    };
    /**
     * Apply loaded data to form
     *
     * @private
     * @param {Room} room
     * @memberof CreateReservationDialogComponent
     */
    CreateDeviceReservationDialogComponent.prototype.initLoadedDates = function (room) {
        var _this = this;
        // room data if set
        this.form.formGroup.patchValue({
            roomNumber: room ? room.Designation : '',
            seats: room ? room.NumberPersons : '',
            title: this.reservation.Designation,
            furtherDetails: this.reservation.FurtherInformation
        });
        if (this.isNewReservation) {
            this.initPresetDate();
        }
        else {
            this.reservation.Occupancies.forEach(function (o) {
                var group = CreateReservationDateComponent.createFormGroupModel(_this.fb);
                group.setValue({
                    id: o.LessonId,
                    date: o.DateTimeFrom.toISOString(),
                    dateTimeFrom: String(DateHelper.getMinutesOfDay(o.DateTimeFrom)),
                    dateTimeTo: String(DateHelper.getMinutesOfDay(o.DateTimeTo)),
                    message: ''
                });
                if (!o.IsEditable) {
                    group.disable();
                }
                _this.dates.push(group);
            });
        }
        this.initReadonlyState();
    };
    return CreateDeviceReservationDialogComponent;
}(CreateReservationDialogComponent));
export { CreateDeviceReservationDialogComponent };
